export function parseLocalStorage(key: string, defaultValue: any, allowedValues?: any[]) {
  const item = window.localStorage.getItem(key);
  if (!item) {
    return defaultValue;
  }
  const value = JSON.parse(item);
  if (value) {
    if (allowedValues && !allowedValues.includes(value)) {
      return defaultValue;
    }
    return value;
  }
  return defaultValue;
}

export function saveLocalStorage(key: string, value: any) {
  window.localStorage.setItem(key, JSON.stringify(value));
}

export function clearLocalStorage(key: string) {
  window.localStorage.removeItem(key);
}
